import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { initRudderStack } from './rudderstack';
import { uid } from './uid';
export var GenericAnalyticsClient = /*#__PURE__*/function () {
  function GenericAnalyticsClient(props) {
    _classCallCheck(this, GenericAnalyticsClient);

    _defineProperty(this, "identify", function () {
      return null;
    });

    _defineProperty(this, "page", function () {
      return null;
    });

    _defineProperty(this, "track", function () {
      return null;
    });

    _defineProperty(this, "flush", void 0);

    _defineProperty(this, "getAnonymousId", function () {
      return '';
    });

    _defineProperty(this, "analytics", void 0);

    _defineProperty(this, "rudderStackConfig", void 0);

    _defineProperty(this, "defaultContext", {});

    this.rudderStackConfig = props.rudderStack;
    this.shimRudderStack(); // Note: needs to be run after initialization of analytics client ^

    this.setInitialContext();
  }
  /**
   * Persists context across all events
   */


  _createClass(GenericAnalyticsClient, [{
    key: "setContext",
    value: function setContext(context) {
      this.defaultContext = _objectSpread(_objectSpread({}, this.defaultContext), context);
    }
    /**
     * Returns persisted context
     */

  }, {
    key: "getContext",
    value: function getContext() {
      return this.defaultContext;
    }
    /**
     * Ensures that persisted context is sent for all track events
     */

  }, {
    key: "mergeContext",
    value: function mergeContext() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _objectSpread(_objectSpread({}, options), {}, {
        context: _objectSpread(_objectSpread({}, (options === null || options === void 0 ? void 0 : options.context) || {}), this.defaultContext)
      });
    }
    /**
     * Ensures that sessionId is sent as a property for all track events
     */

  }, {
    key: "mergeSessionId",
    value: function mergeSessionId() {
      var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var _ref = this.defaultContext,
          sessionId = _ref.sessionId;
      return _objectSpread({
        sessionId: sessionId
      }, fields);
    }
    /**
     * Initializes default context that is sent for all events
     */

  }, {
    key: "setInitialContext",
    value: function setInitialContext() {
      var _navigator, _navigator2, _document, _document2, _navigator3;

      this.setContext({
        sessionId: uid(),
        // Default session id, will be overridden for web view sessions
        platform: 'web',
        userAgent: (_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.userAgent,
        locale: (_navigator2 = navigator) === null || _navigator2 === void 0 ? void 0 : _navigator2.language,
        page: {
          title: (_document = document) === null || _document === void 0 ? void 0 : _document.title,
          referrer: (_document2 = document) === null || _document2 === void 0 ? void 0 : _document2.referrer,
          path: window.location.pathname,
          url: window.location.href,
          search: window.location.search
        },
        screen: {
          width: document.body.clientWidth,
          height: document.body.clientHeight
        },
        device: {
          platform: (_navigator3 = navigator) === null || _navigator3 === void 0 ? void 0 : _navigator3.platform
        }
      });
    }
    /**
     * Wraps `identify`, `page`, and `track` RudderStack calls for passing persisted context values
     */

  }, {
    key: "shimRudderStack",
    value: function shimRudderStack() {
      var _this = this;

      this.analytics = initRudderStack(this.rudderStackConfig);

      this.identify = function (id, traits, options, callback) {
        return _this.analytics.identify(id, traits, _this.mergeContext(options), callback);
      };

      this.page = function (category, name, properties, options, callback) {
        return _this.analytics.page(category, name, _this.mergeSessionId(properties), _this.mergeContext(options), callback);
      };

      this.track = function (event, properties, options, callback) {
        return _this.analytics.track(event, _this.mergeSessionId(properties), _this.mergeContext(options), callback);
      };

      this.getAnonymousId = function () {
        return _this.analytics.getAnonymousId();
      };
    }
  }]);

  return GenericAnalyticsClient;
}();